import { useConfig } from '../../providers/config'
import { useScript } from '../use-script/useScript'

/**
 * @returns {"idle" | "loading" | "ready" | "error"} status
 */
export const useGoogleMaps = () => {
	const { googleMaps } = useConfig()
	const script = {
		src: `https://maps.googleapis.com/maps/api/js?key=${googleMaps?.apiKey}&libraries=${googleMaps?.libraries?.join(
			','
		)}`,
		attributes: { id: 'googleMapsApi' },
	}

	return useScript(script)
}
